<template lang="pug">
  li.team-match(:class="{ 'isGeneral': card.isGeneral }")
    .match-header
      .header-top
        .header-left
          .walk-icon(aria-hidden="true")
            svg(viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg")
              path(
                fill="currentColor"
                d="M13.5 5.5a2 2 0 1 0-2 0V8l-3.2 1.6L6 14.5l1.7.7 1.8-4.2 2 .9V20h2v-7.5l2.2-1.1L17.5 15l1.5-1-2.7-5.2L13.5 8V5.5z"
              )
          .result-badge(v-if="card.phase === 'result'") 最終結果発表!!
          .date(v-else-if="card.phase === 'beforeStart'") {{ card.startDateTime | formatDate }}から開催します
          .date(v-else-if="card.phase === 'inProgress'") {{ card.startDateTime | formatDate }}〜{{ card.displayEndDateTime | formatDate }}
          .date(v-else-if="card.phase === 'calculating'") 集計が終わりました<br>最終結果をお楽しみに！
        .chevron(aria-hidden="true")
          img(src="@/assets/images/icon_arrow.svg" alt="")
      .title {{ card.name }}
      .debug-phase-switch(v-if="isDevelopment")
        button(type="button" @click="$emit('set-debug-phase', card.id, 'noTeam')") 編成前
        button(type="button" @click="$emit('set-debug-phase', card.id, 'forming')") 編成中
        button(type="button" @click="$emit('set-debug-phase', card.id, 'formed')") 編成後
        button(type="button" @click="$emit('set-debug-phase', card.id, 'inProgress')") 期間中
        button(type="button" @click="$emit('set-debug-phase', card.id, 'calculating')") 集計中
        button(type="button" @click="$emit('set-debug-phase', card.id, 'result')") 最終結果
    .match-body
      .status-message(v-if="card.bodyType === 'noTeam'")
        p チームを作成するか<br>チームに参加してください
      .status-message(v-else-if="card.bodyType === 'forming'")
        p チーム編成中
      .team-name-only(v-else-if="card.bodyType === 'formed'") {{ card.teamName }}
      template(v-else)
        .team-row
          .team-name {{ card.teamName }}
          .chat-button
            span.chat-label チャット
            span.chat-badge(v-if="card.chatBadgeCount > 0") {{ card.chatBadgeCount }}
        .stats
          .stat
            .label チーム順位
            .value {{ card.rankText }} 位
          .stat
            .label チーム平均歩数
            .value {{ card.stepsText }} 歩
        .result-schedule(v-if="card.bodyType === 'calculating'")
          .label 最終結果発表予定日
          .value {{ card.resultStartDateTime | formatDate }}
</template>
<script>
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
    isDevelopment: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss">
.team-match {
  border: 1px dashed $base-brand-color;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 12px;
  padding: 12px;
}

.match-header {
  .header-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
  }

  .header-left {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    min-width: 0;
  }

  .walk-icon {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: $base-brand-color;
    margin-top: 1px;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .date {
    color: $base-brand-color;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.4;
  }

  .result-badge {
    display: inline-block;
    background: $base-color-red;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    border-radius: 12px;
    padding: 2px 10px;
  }

  .chevron {
    flex-shrink: 0;
    width: 8px;
    margin-top: 4px;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    color: $base-color;
    line-height: 1.4;
  }

  .debug-phase-switch {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;

    button {
      border: 1px solid $base-brand-color;
      padding: 4px 10px;
      font-size: 11px;
      color: $base-brand-color;
      background: #fff;
    }
  }
}

.match-body {
  margin-top: 12px;

  .status-message {
    background: #eef4fb;
    border-radius: 4px;
    padding: 16px 12px;
    text-align: center;

    p {
      margin: 0;
      font-size: 14px;
      font-weight: bold;
      color: $base-color;
      line-height: 1.5;
    }
  }

  .team-name-only {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: $base-color;
    padding: 8px 0;
  }

  .team-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .team-name {
    font-size: 16px;
    font-weight: bold;
    color: $base-color;
    min-width: 0;
    word-break: break-word;
  }

  .chat-button {
    position: relative;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 88px;
    height: 32px;
    padding: 0 16px;
    border-radius: 16px;
    background: $base-color-red;
    color: #fff;
    font-size: 13px;
    font-weight: bold;
  }

  .chat-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: 10px;
    background: $base-color-red;
    border: 2px solid #fff;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    line-height: 16px;
    text-align: center;
    box-sizing: border-box;
  }

  .stats {
    display: flex;
    background: #eef4fb;
    border-radius: 4px;
    padding: 12px 8px;

    .stat {
      flex: 1;
      text-align: center;

      &:first-child {
        border-right: 1px solid #c5d4e8;
      }

      .label {
        font-size: 12px;
        color: $base-color;
        margin-bottom: 4px;
      }

      .value {
        font-size: 16px;
        font-weight: bold;
        color: $base-brand-color;
      }
    }
  }

  .result-schedule {
    margin-top: 8px;
    background: #eef4fb;
    border-radius: 4px;
    padding: 12px;
    text-align: center;

    .label {
      font-size: 12px;
      color: $base-color;
      margin-bottom: 4px;
    }

    .value {
      font-size: 16px;
      font-weight: bold;
      color: $base-color;
    }
  }
}

.team-match.isGeneral {
  border-color: $base-brand-color;
}
</style>
